/* ==========================================================================
   Bike Flow — global.js
   Al interaktivitet i ren vanilla JS. Ingen afhængigheder.
   Moduler initialiseres kun, når deres DOM-elementer findes på siden.
   ========================================================================== */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {}, moneyFormat: '{{ amount }} kr.' };

  /* ------------------------------------------------------------------
     Hjælpere
     ------------------------------------------------------------------ */
  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var moneyFormat = format || theme.moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || '.';
      decimal = decimal || ',';

      if (isNaN(number) || number == null) return '0';

      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch (moneyFormat.match(placeholderRegex) ? moneyFormat.match(placeholderRegex)[1] : 'amount') {
      case 'amount':
        value = formatWithDelimiters(cents, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return moneyFormat.replace(placeholderRegex, value);
  }

  var toastTimer = null;
  function showToast(message, showCartLink) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    var text = toast.querySelector('[data-toast-text]');
    var link = toast.querySelector('[data-toast-link]');

    if (text) text.textContent = message;
    if (link) link.hidden = !showCartLink;

    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
      }, 260);
    }, 4200);
  }

  function updateCartCount() {
    fetch((theme.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
     Header: skygge ved scroll + søgepanel
     ------------------------------------------------------------------ */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 4);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var panel = document.querySelector('[data-search-panel]');
    var toggles = document.querySelectorAll('[data-search-toggle]');
    if (!panel || !toggles.length) return;

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', String(open)); });
        if (open) {
          var input = panel.querySelector('[data-search-input]');
          if (input) input.focus();
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) {
        panel.hidden = true;
        toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  /* ------------------------------------------------------------------
     Mobilmenu (drawer)
     ------------------------------------------------------------------ */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var openBtn = document.querySelector('[data-drawer-open]');

    function open() {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstLink = drawer.querySelector('a, button, summary');
      if (firstLink) firstLink.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        drawer.hidden = true;
      }, 280);
      if (openBtn) openBtn.focus();
    }

    if (openBtn) openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ------------------------------------------------------------------
     Antalsvælgere (produktside m.m.)
     ------------------------------------------------------------------ */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var wrap = (minus || plus).closest('[data-qty]');
      if (!wrap) return;
      var input = wrap.querySelector('.qty__input');
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      value = plus ? value + 1 : Math.max(min, value - 1);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------------
     Produktkort: hover på en farveprik viser den farves billede
     ------------------------------------------------------------------ */
  function initCardSwatches() {
    document.addEventListener('mouseover', function (e) {
      var swatch = e.target.closest('.card [data-swatch-image]');
      if (!swatch) return;
      var card = swatch.closest('.card');
      var img = card && card.querySelector('.card__img');
      if (!img || img.classList.contains('card__img--placeholder')) return;
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.currentSrc || img.src;
        img.dataset.originalSrcset = img.getAttribute('srcset') || '';
      }
      img.removeAttribute('srcset');
      img.src = swatch.dataset.swatchImage;
    });

    // Touch har ingen hover — et tryk vælger farven og bliver stående
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.card [data-swatch-image]');
      if (!swatch) return;
      var card = swatch.closest('.card');
      var img = card && card.querySelector('.card__img');
      if (!img || img.classList.contains('card__img--placeholder')) return;

      img.removeAttribute('srcset');
      img.src = swatch.dataset.swatchImage;
      // den valgte farve bliver det nye udgangspunkt, så hover ikke ruller den tilbage
      img.dataset.originalSrc = swatch.dataset.swatchImage;
      img.dataset.originalSrcset = '';

      card.querySelectorAll('.swatches .swatch').forEach(function (d) {
        d.classList.toggle('is-active', d === swatch);
      });
    });

    document.addEventListener('mouseout', function (e) {
      var swatches = e.target.closest('.card .swatches');
      if (!swatches) return;
      // stadig inde i prikkerne? så er det bare et skift mellem to prikker
      if (e.relatedTarget && swatches.contains(e.relatedTarget)) return;
      var card = swatches.closest('.card');
      var img = card && card.querySelector('.card__img');
      if (!img || !img.dataset.originalSrc) return;
      img.src = img.dataset.originalSrc;
      if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
    });
  }

  /* ------------------------------------------------------------------
     Produktside: varianter, galleri og AJAX-kurv
     ------------------------------------------------------------------ */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    var dataEl = document.querySelector('[data-product-data]');
    if (!form || !dataEl) return;

    var productData;
    try {
      productData = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }

    var variants = productData.variants || [];
    var mediaMap = {};
    (productData.media || []).forEach(function (m) {
      mediaMap[m.id] = m.src;
    });

    var idInput = form.querySelector('[data-variant-id]');

    /* Optionsvælgere: dropdowns og farveprikker behandles ens.
       Hver vælger kender sit indeks i variant.options og sin valgte værdi. */
    var pickers = [];
    form.querySelectorAll('[data-option-select]').forEach(function (sel) {
      pickers.push({
        index: parseInt(sel.dataset.optionIndex, 10),
        el: sel,
        get: function () { return sel.value; }
      });
    });
    form.querySelectorAll('[data-option-swatches]').forEach(function (group) {
      pickers.push({
        index: parseInt(group.dataset.optionIndex, 10),
        el: group,
        get: function () {
          var active = group.querySelector('[data-option-value].is-active');
          return active ? active.dataset.optionValue : '';
        }
      });
    });
    pickers.sort(function (a, b) { return a.index - b.index; });
    var addButton = form.querySelector('[data-add-button]');
    var addLabel = form.querySelector('[data-add-label]');
    var priceWrapper = document.querySelector('[data-price-wrapper]');
    var stockEl = document.querySelector('[data-stock]');
    var mainImage = document.querySelector('[data-main-image]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var addonChecks = Array.prototype.slice.call(form.querySelectorAll('[data-addon]'));
    var addonsTotal = form.querySelector('[data-addons-total]');

    function addonRow(check) {
      return check.closest('.addon');
    }

    // Valgt tilbehør som linjer til /cart/add.js
    function selectedAddons() {
      return addonChecks
        .filter(function (check) { return check.checked; })
        .map(function (check) {
          var select = addonRow(check).querySelector('[data-addon-variant]');
          var source = select ? select.options[select.selectedIndex] : check;
          return {
            id: parseInt(select ? select.value : check.dataset.variantId, 10),
            price: parseInt(source.dataset.price, 10) || 0,
            quantity: 1
          };
        })
        .filter(function (item) { return item.id; });
    }

    function renderAddonsTotal() {
      if (!addonsTotal) return;
      var addons = selectedAddons();
      if (!addons.length) {
        addonsTotal.hidden = true;
        return;
      }
      var variant = currentVariant();
      var quantity = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var total = (variant ? variant.price * quantity : 0);
      addons.forEach(function (addon) { total += addon.price; });
      addonsTotal.hidden = false;
      addonsTotal.textContent = theme.strings.addonsTotal + ': ' + formatMoney(total);
    }

    function currentVariant() {
      if (!pickers.length) {
        var id = parseInt(idInput.value, 10);
        return variants.find(function (v) { return v.id === id; }) || variants[0];
      }
      var chosen = pickers.map(function (p) { return p.get(); });
      return variants.find(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      });
    }

    function renderPrice(variant) {
      if (!priceWrapper) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html = '<div class="price price--lg' + (onSale ? ' price--on-sale' : '') + '">';
      html += '<span class="price__amount">' + formatMoney(variant.price) + '</span>';
      if (onSale) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>';
      }
      html += '</div>';
      priceWrapper.innerHTML = html;
    }

    function renderStock(variant) {
      if (!stockEl) return;
      if (variant.available) {
        stockEl.innerHTML = '<span class="stock-dot" aria-hidden="true"></span>' + theme.strings.inStock;
      } else {
        stockEl.innerHTML = '<span class="stock-dot stock-dot--out" aria-hidden="true"></span>' + theme.strings.soldOut;
      }
    }

    function setActiveThumb(mediaId) {
      document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId));
      });
    }

    function previewImage(src) {
      if (!mainImage || !src) return;
      if (!mainImage.dataset.currentSrc) mainImage.dataset.currentSrc = mainImage.src;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
    }

    function restoreImage() {
      if (!mainImage || !mainImage.dataset.currentSrc) return;
      mainImage.src = mainImage.dataset.currentSrc;
    }

    function onVariantChange() {
      var variant = currentVariant();

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = theme.strings.unavailable;
        }
        return;
      }

      idInput.value = variant.id;
      renderPrice(variant);
      renderStock(variant);

      if (addButton) {
        addButton.disabled = !variant.available;
        if (addLabel) {
          addLabel.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
      }

      if (variant.featured_media && mainImage && mediaMap[variant.featured_media.id]) {
        mainImage.removeAttribute('srcset');
        mainImage.src = mediaMap[variant.featured_media.id];
        mainImage.dataset.currentSrc = mainImage.src;
        setActiveThumb(variant.featured_media.id);
      }

      renderAddonsTotal();

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    pickers.forEach(function (picker) {
      if (picker.el.tagName === 'SELECT') {
        picker.el.addEventListener('change', onVariantChange);
        return;
      }

      // Farveprikker: klik vælger, hover viser farvens billede uden at vælge
      picker.el.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        picker.el.querySelectorAll('[data-option-value]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        var nameEl = document.querySelector('[data-option-current="' + picker.index + '"]');
        if (nameEl) nameEl.textContent = btn.dataset.optionValue;
        onVariantChange();
      });

      picker.el.addEventListener('mouseover', function (e) {
        var btn = e.target.closest('[data-swatch-image]');
        if (btn) previewImage(btn.dataset.swatchImage);
      });
      picker.el.addEventListener('mouseleave', restoreImage);
    });

    // Tilbehør: opdatér totalen når der vælges til/fra, skiftes variant eller antal
    if (addonChecks.length) {
      form.addEventListener('change', function (e) {
        if (e.target.closest('[data-addon], [data-addon-variant]') || e.target === qtyInput) {
          renderAddonsTotal();
        }
      });
    }

    // Galleri: klik på miniature skifter hovedbilledet
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.dataset.src;
        mainImage.dataset.currentSrc = thumb.dataset.src;
        setActiveThumb(thumb.dataset.mediaId);
      });
    });

    // AJAX-tilføj til kurv
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!addButton || addButton.disabled) return;

      var originalLabel = addLabel ? addLabel.textContent : '';
      addButton.disabled = true;
      if (addLabel) addLabel.textContent = theme.strings.adding;

      // Med valgt tilbehør sendes varen og tilbehøret som ét kald med flere linjer
      var addons = selectedAddons();
      var request;

      if (addons.length) {
        var items = [
          {
            id: parseInt(idInput.value, 10),
            quantity: parseInt(qtyInput && qtyInput.value, 10) || 1
          }
        ].concat(
          addons.map(function (addon) {
            return { id: addon.id, quantity: addon.quantity };
          })
        );

        request = fetch(theme.routes.cartAdd + '.js', {
          method: 'POST',
          body: JSON.stringify({ items: items }),
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
        });
      } else {
        request = fetch(theme.routes.cartAdd + '.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        });
      }

      request
        .then(function (res) {
          return res.json().then(function (json) {
            return { ok: res.ok, json: json };
          });
        })
        .then(function (result) {
          if (result.ok) {
            updateCartCount();
            showToast(theme.strings.added, true);
            addonChecks.forEach(function (check) { check.checked = false; });
            renderAddonsTotal();
          } else {
            showToast(result.json.description || theme.strings.cartError, false);
          }
        })
        .catch(function () {
          showToast(theme.strings.cartError, false);
        })
        .finally(function () {
          addButton.disabled = false;
          if (addLabel) addLabel.textContent = originalLabel;
        });
    });
  }

  /* ------------------------------------------------------------------
     Kurvside: antal og fjern via /cart/change.js
     ------------------------------------------------------------------ */
  function initCartPage() {
    var cartForm = document.querySelector('[data-cart-form]');
    if (!cartForm) return;

    function changeLine(lineEl, quantity) {
      var line = parseInt(lineEl.dataset.cartLine, 10);
      lineEl.classList.add('is-busy');

      fetch(theme.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          window.location.reload();
        })
        .catch(function () {
          lineEl.classList.remove('is-busy');
          showToast(theme.strings.cartError, false);
        });
    }

    cartForm.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-remove]');
      var qtyBtn = e.target.closest('[data-cart-qty-change]');

      if (removeBtn) {
        var lineEl = removeBtn.closest('[data-cart-line]');
        if (lineEl) changeLine(lineEl, 0);
        return;
      }

      if (qtyBtn) {
        var lineEl2 = qtyBtn.closest('[data-cart-line]');
        var input = lineEl2 && lineEl2.querySelector('[data-cart-qty-input]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.dataset.cartQtyChange, 10);
        if (next < 0) next = 0;
        changeLine(lineEl2, next);
      }
    });

    cartForm.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input) return;
      var lineEl = input.closest('[data-cart-line]');
      var value = parseInt(input.value, 10);
      if (isNaN(value) || value < 0) value = 0;
      if (lineEl) changeLine(lineEl, value);
    });
  }

  /* ------------------------------------------------------------------
     Kategoriside: sortering + filtre i sidepanel (drawer på mobil)
     ------------------------------------------------------------------ */
  function initFacets() {
    var form = document.querySelector('[data-facets-form]');
    var sortSelect = document.querySelector('[data-sort-select]');
    var sidebar = document.querySelector('[data-facets-sidebar]');
    var overlay = document.querySelector('.facets-overlay');
    var desktop = window.matchMedia('(min-width: 990px)');

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        if (form) {
          form.submit();
        } else {
          // Ingen filtre: sortér via URL-parameter
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSelect.value);
          window.location.href = url.toString();
        }
      });
    }

    if (!form || !sidebar) return;

    // Desktop: anvend filtre med det samme. Mobil: vent på "Vis resultater".
    form.addEventListener('change', function (e) {
      if (e.target.matches('.facet__value input[type="checkbox"]') && desktop.matches) {
        form.submit();
      }
    });

    function openFilters() {
      sidebar.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('[data-filters-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });
    }

    function closeFilters() {
      sidebar.classList.remove('is-open');
      if (overlay) overlay.hidden = true;
      document.body.style.overflow = '';
      document.querySelectorAll('[data-filters-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.querySelectorAll('[data-filters-open]').forEach(function (btn) {
      btn.addEventListener('click', openFilters);
    });
    document.querySelectorAll('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', closeFilters);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeFilters();
    });
  }

  /* ------------------------------------------------------------------
     Log ind: skift mellem login og "glemt adgangskode"
     ------------------------------------------------------------------ */
  function initLoginToggle() {
    var loginView = document.querySelector('[data-login-view]');
    var recoverView = document.querySelector('[data-recover-view]');
    if (!loginView || !recoverView) return;

    function setRecover(showRecover) {
      loginView.hidden = showRecover;
      recoverView.hidden = !showRecover;
    }

    document.querySelectorAll('[data-recover-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setRecover(recoverView.hidden);
      });
    });

    // Vis recover-visningen efter et (fejlet/lykkedes) recover-postback eller #recover-link
    if (window.location.hash === '#recover' || recoverView.querySelector('.form-success, .form-error')) {
      setRecover(true);
    }
  }

  /* ------------------------------------------------------------------
     Adresser: lande/region-vælger og slet-bekræftelse
     ------------------------------------------------------------------ */
  function initAddresses() {
    document.querySelectorAll('[data-address-country]').forEach(function (countrySelect) {
      var wrap = countrySelect.closest('form');
      if (!wrap) return;
      var provinceWrap = wrap.querySelector('[data-province-wrap]');
      var provinceSelect = wrap.querySelector('[data-address-province]');
      if (!provinceSelect) return;

      function updateProvinces() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];
        try {
          provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
        } catch (err) {}

        provinceSelect.innerHTML = '';
        if (!provinces.length) {
          if (provinceWrap) provinceWrap.hidden = true;
          return;
        }
        provinces.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p[0];
          opt.textContent = p[1];
          provinceSelect.appendChild(opt);
        });
        var def = provinceSelect.getAttribute('data-default');
        if (def) provinceSelect.value = def;
        if (provinceWrap) provinceWrap.hidden = false;
      }

      var defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) countrySelect.value = defaultCountry;
      updateProvinces();
      countrySelect.addEventListener('change', updateProvinces);
    });

    document.addEventListener('click', function (e) {
      var confirmBtn = e.target.closest('[data-confirm]');
      if (confirmBtn && !window.confirm(confirmBtn.dataset.confirm)) {
        e.preventDefault();
      }
    });
  }

  /* ------------------------------------------------------------------
     Init
     ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initDrawer();
    initQtySteppers();
    initCardSwatches();
    initProductForm();
    initCartPage();
    initFacets();
    initLoginToggle();
    initAddresses();
  });
})();
